import "../styles/DesktopSettings.scss";

import React from "react";

import withBulkFollowUnfollow from "../../../../../hocs/withBulkFollowUnfollow";
import withUserData from "../../../../../hocs/withUserData";
import getAccessLevel from "../../../../../lib/access/getAccessLevel";
import handleAccess from "../../../../../lib/access/handleAccess";
import AnalyticsEventTrackerWeb from "../../../../../lib/AnalyticsEventTracker/AnalyticsEventTrackerWeb";
import YellowSwitch from "../../../../../lib/SquaberThemeComponents/YellowSwitch";
import TagsHelper from "../../../../../lib/TagsHelper/TagsHelper";
import { PLAN_PERMISSIONS_NAMES } from "../../../../../redux/modules/auth/userPermissions/selector";
import SquaberButton from "../../SquaberButton/modules/default";
import DesktopSorting from "./DesktopSorting";
import DesktopViewTypeSelect from "./DesktopViewTypeSelect";

@withBulkFollowUnfollow
@withUserData
class DesktopSettings extends React.Component {
  render() {
    const {
      settings,
      options,
      setSortBy,
      setViewType,
      setAdvancedView,
      translate,
      tagData,
      bulkFollow,
      bulkUnFollow,
      userData,
      canDisplaySection
    } = this.props;

    const { name } = tagData;

    const currentTagIsAlertedTag = TagsHelper.isAlertedTag(tagData);
    const userAccessLevel = getAccessLevel(userData);
    const stockIds = tagData.stocks.map(stock => stock.id);

    return (
      <div className="desktop-settings">
        <div className="desktop-settings__text-block">
          {translate("View type")}:
        </div>
        <DesktopViewTypeSelect
          options={options.viewTypes}
          value={settings.viewType}
          onChange={value => {
            setViewType(value);
          }}
        />
        {settings.viewType === "grid" ? (
          <React.Fragment>
            <div className="desktop-settings__text-block">
              {translate("Sort by")}:
            </div>
            <DesktopSorting
              options={options.sortOptions}
              value={settings.sortBy}
              onChange={value => {
                setSortBy(value);
              }}
            />
            <div className="desktop-settings__text-block">
              {translate("Advanced view")}:
            </div>
            <YellowSwitch
              checked={settings.advancedView}
              onChange={() => {
                setAdvancedView(!settings.advancedView);
              }}
              value="advanced_view"
              color="primary"
            />
          </React.Fragment>
        ) : null}
        {!currentTagIsAlertedTag ? (
          <React.Fragment>
            <div className="desktop-settings__text-block pull-right">
              {translate("Alert stocks")}:
            </div>
            <SquaberButton
              color={"dark"}
              onClick={() => {
                if (canDisplaySection(PLAN_PERMISSIONS_NAMES.ALERTED_STOCKS)) {
                  bulkFollow({ stocks: stockIds });
                  AnalyticsEventTrackerWeb.trackStockAlertOnEvent({
                    type: "list",
                    market: "list",
                    name
                  });
                } else {
                  handleAccess(userAccessLevel, undefined, [
                    PLAN_PERMISSIONS_NAMES.ALERTED_STOCKS
                  ]);
                }
              }}
            >
              <i className="fas fa-bell" /> <span>{translate("All")}</span>
            </SquaberButton>
            <SquaberButton
              color={"dark"}
              onClick={() => {
                if (canDisplaySection(PLAN_PERMISSIONS_NAMES.ALERTED_STOCKS)) {
                  bulkUnFollow({ stocks: stockIds });
                } else {
                  handleAccess(userAccessLevel, undefined, [
                    PLAN_PERMISSIONS_NAMES.ALERTED_STOCKS
                  ]);
                }
              }}
            >
              <i className="fal fa-bell-slash" />{" "}
              <span>{translate("None")}</span>
            </SquaberButton>
          </React.Fragment>
        ) : null}
      </div>
    );
  }
}

export default DesktopSettings;
